(function () {
  var MOBILE_Q = '(max-width: 749px)';

  function ensureId(el) {
    if (!el.id) el.id = 'grid-sldr-' + Math.random().toString(36).slice(2);
    return el.id;
  }

  function getProgressBar(el) {
    var id = ensureId(el);
    var prog = el.querySelector('.pi-progress[data-progress-for="' + id + '"]');
    if (!prog) {
      prog = document.createElement('div');
      prog.className = 'pi-progress';
      prog.setAttribute('data-progress-for', id);
      var bar = document.createElement('span');
      bar.className = 'pi-progress__bar';
      prog.appendChild(bar);
      el.appendChild(prog);
    }
    return prog.querySelector('.pi-progress__bar');
  }

  function initSlider(el) {
    if (el.__flkty) return;

    // eslint-disable-next-line no-undef
    var flkty = new Flickity(el, {
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: false,
      setGallerySize: true,
      imagesLoaded: true,
      resize: true
    });

    el.__flkty = flkty;

    var bar = getProgressBar(el);

    function updateBar() {
      if (!bar || !flkty) return;
      var total = (flkty.slides && flkty.slides.length) || 1;

      // ✅ Hide progress bar if only one slide
      var prog = bar.parentElement;
      if (prog) prog.style.display = total <= 1 ? 'none' : 'block';

      if (total <= 1) return; // no update needed

      var idx = (typeof flkty.selectedIndex === 'number') ? flkty.selectedIndex : 0;
      if (idx < 0) idx = 0;
      if (idx > total - 1) idx = total - 1;
      bar.style.width = (((idx + 1) / total) * 100) + '%';
    }

    flkty.on('ready', updateBar);
    flkty.on('select', updateBar);
    flkty.on('change', updateBar);
    window.addEventListener('resize', updateBar);
    updateBar();
  }

  function destroySlider(el) {
    if (!el.__flkty) return;
    el.__flkty.destroy();
    el.__flkty = null;
  }

  function syncSliders(mq) {
    var sliders = document.querySelectorAll('[data-grid-sldr]');
    var allow = mq.matches || (window.Shopify && Shopify.designMode);
    sliders.forEach(function (el) {
      if (allow) initSlider(el);
      else destroySlider(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var mq = window.matchMedia(MOBILE_Q);
    syncSliders(mq);

    if (mq.addEventListener) {
      mq.addEventListener('change', function () { syncSliders(mq); });
    } else {
      mq.addListener(function () { syncSliders(mq); });
    }
  });
})();
